module.exports = __webpack_public_path__ + "static/media/avatar_tiger.d7ee0e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_tiger.png
// module id = 399
// module chunks = 0